import { Block } from "modules/Block";

import utm from "modules/utm";
import formSelectTemplate from "./FormSelect.hbs";

import "./form-block.scss";

import { replaceHiddenInputValues } from 'modules/replaceHiddenInputValues';
import { replaceSentFromFormValues } from 'modules/replaceSentFromFormValues';


export class FormBlock extends Block<typeof FormBlock> {
  static readonly className: string = "js-form-block";

  constructor(rootElement: HTMLElement, index: number) {
    super(rootElement, index);

    this.styleButtons();
    this.renderCustomSelect();
    this.nativeSelects();
    const utmParams = utm.getUtmTagsFromUrlOrCookie();
    this.addUTMValuesToHiddenInputs(utmParams);
     replaceHiddenInputValues();
      replaceSentFromFormValues();
  }

  addUTMValuesToHiddenInputs = (utmParams: any) => {
    for (const kvp of utmParams) {
      const name = kvp[0];
      const value = kvp[1];
      /** @type {NodeListOf<HTMLInputElement>} */
      const hiddenInputs = this.rootElement.querySelectorAll(
        `input[type="hidden"][value="${name}"]`
      );

      hiddenInputs.forEach((input: any) => {
        input.value = value;
      });
    }
  };

  cookieConsent = () => {
    const cookieBanner = document.getElementById("onetrust-consent-sdk");
    if (cookieBanner != null) {
      const allButtons = cookieBanner.getElementsByTagName(
        "button"
      ) as HTMLCollectionOf<HTMLButtonElement>;

      for (let i = 0; i < allButtons.length; i++) {
        allButtons[i].onclick = () => this.refreshPage();
      }
    }
  };
  refreshPage = () => {
    location.reload();
  };
  styleButtons = () => {
    const submitButtons = this.rootElement.querySelectorAll(
      `.Form__MainBody .FormSubmitButton`
      );

    const resetButtons = this.rootElement.querySelectorAll(
        `.Form__MainBody .FormResetButton `
    );

    submitButtons.forEach((button) => {
        const sibling = button.nextElementSibling;

        if (sibling?.classList.contains("FormResetButton")) {
            const wrapper = document.createElement("div");
            wrapper.classList.add("Form__Element");
            wrapper.classList.add("buttons-wrapper");
            button.before(wrapper);

            wrapper.appendChild(button);            
        }
    });

    resetButtons.forEach((button) => {           
        const sibling = button.previousElementSibling;

        if (sibling?.classList.contains("buttons-wrapper")) {
            sibling.appendChild(button);
        }         
    });
  };
  renderCustomSelect = () => {
    const selects = this.rootElement.querySelectorAll(".Form__MainBody select");
    let customSelectIdTracker = 0;
    selects.forEach((select) => {
      const selectOptions: NodeListOf<HTMLOptionElement> =
        select.querySelectorAll("option:not([disabled='disabled'])");

      const data = {
        selectTitle:
          (
            select.querySelector(
              "option[disabled='disabled']"
            ) as HTMLOptionElement
          )?.innerText ?? "",
        selectMultiple: false,
        selectedString: "",
        selectOptions: [] as Array<{
          optionValue: string;
          optionText: string;
          isSelected: boolean;
        }>,
      };

      // Check if select is multiselect
      if (select.hasAttribute("multiple")) {
        data.selectMultiple = true;
      }

      selectOptions.forEach((selectOption) => {
        const selectOptionValue = selectOption.value;
        const selectOptionText = selectOption.innerText as string;

        const isSelected = selectOption.selected;

        if (selectOption.selected) {
          if (data.selectedString === "") {
            data.selectedString = selectOptionText;
          } else {
            data.selectedString += `, ${selectOptionText}`;
          }
        }

        const obj = {
          optionValue: selectOptionValue,
          optionText: selectOptionText,
          isSelected: isSelected,
        };

        if (!selectOption.disabled) {
          data.selectOptions.push(obj);
        }
      });

      const formSelectWrapperNode = document.createElement("div");
      formSelectWrapperNode.classList.add("form-select");
      formSelectWrapperNode.setAttribute("tabindex", "0"); // Converting number to string
      formSelectWrapperNode.setAttribute("role", "listbox");
      formSelectWrapperNode.setAttribute(
        "aria-controls",
        `custom-select-${customSelectIdTracker}`
      ); // Converting number to string
      formSelectWrapperNode.setAttribute("aria-expanded", "false"); // Converting boolean to string

      select.insertAdjacentElement("beforebegin", formSelectWrapperNode);

      formSelectWrapperNode.innerHTML = formSelectTemplate(data);

      this.toggleCustomSelect(formSelectWrapperNode);
      this.handleOptionSelect(formSelectWrapperNode, data.selectMultiple);
      customSelectIdTracker++;
    });
  };
  toggleCustomSelect = (select: HTMLDivElement) => {
    const selectHeader = select.querySelector(".form-header") as Element;
    select.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggle();
        listTabEnable();
      }
    });
    selectHeader.addEventListener("click", () => {
      toggle();
    });
    function listTabEnable() {
      select.querySelectorAll(".form-list li").forEach((item) => {
        item.setAttribute("tabindex", "0");
        const target = item as HTMLElement;
        target.addEventListener("keydown", function (event: KeyboardEvent) {
          if (event.key === "Enter") {
            event.preventDefault();
            (this as HTMLElement).click();
            toggle();
          }
        });
      });
    }
    function removeTabIndex() {
      setTimeout(() => {
        select.querySelectorAll(".form-list li").forEach((item) => {
          item.removeAttribute("tabindex");
        });
      }, 100);
    }
    function toggle() {
      select.classList.toggle("expanded");

      const isDesktop = document.documentElement.clientWidth > 800;
      const threshold = isDesktop ? 300 : 220;
      const isAboveThreshold =
        document.documentElement.clientHeight -
          selectHeader.getBoundingClientRect().bottom <
        threshold;

      if (isAboveThreshold) {
        select.classList.add("above");
      } else {
        select.classList.remove("above");
      }
      if (!select.classList.value.includes("expanded")) {
        removeTabIndex();
      }
    }
  };

  nativeSelects = () => {
    const selects = this.rootElement.querySelectorAll(
      ".Form__MainBody select"
    ) as NodeListOf<HTMLSelectElement>;

    selects.forEach((select: HTMLSelectElement) => {
      select.addEventListener("change", () => {
        if (document.documentElement.clientWidth < 800) {
          const parentElement = select.parentElement;
          if (!parentElement) return;

          const element = parentElement.querySelector(
            `li[data-value='${select.value}']`
          );

          if (select.hasAttribute("multiple")) {
            if (element) {
              (element as HTMLElement).click();
            } else {
              const formHeaderSpan =
                parentElement.querySelector(".form-header span");
              if (formHeaderSpan) {
                formHeaderSpan.innerHTML = select.options[0].innerHTML;
              }
            }
          } else if (select.value !== "") {
            if (element) {
              (element as HTMLElement).click();
            }
          }
        }
      });
    });
  };
  decodeHTMLEntities = (str: string) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  };
  handleOptionSelect = (select: HTMLDivElement, isMultiple: boolean) => {
    const originalSelect = select.nextElementSibling;

    if (isMultiple) {
      const options = select.querySelectorAll(
        "li[data-type='js-multi-select']"
      );

      options.forEach((option) => {
        option.addEventListener("click", (e) => {
          const target = e.target as HTMLElement; // Cast e.target to HTMLElement
          target.classList.toggle("selected");
          setOptionState();
          originalSelect?.dispatchEvent(new Event("change"));
        });
      });
      setOptionState();
    } else {
      const selectTitleElement = select.querySelector(
        ".form-header span"
      ) as HTMLElement;
      const originalSelectOptions = select.nextElementSibling?.querySelectorAll(
        "option:not([disabled='disabled'])"
      ) as NodeListOf<HTMLElement>;
      const options = select.querySelectorAll(
        "li[data-type='js-single-select']"
      );

      options.forEach((option) => {
        option.addEventListener("click", (e) => {
          const target = e.target as HTMLElement;
          const previousSelectedItem = select.querySelector(".selected");

          select.classList.add("has-selection");

          if (previousSelectedItem !== null) {
            previousSelectedItem.classList.remove("selected");
          }

          target.classList.add("selected");

          // Decode the data-value before using it
          const decodedValue = this.decodeHTMLEntities(
            target.querySelector("span")?.innerHTML ?? ""
          );
          if (selectTitleElement) {
            selectTitleElement.innerText = decodedValue;
          }

          select.classList.remove("expanded");

          if (document.documentElement.clientWidth > 800) {
            originalSelectOptions?.forEach((selectOption) => {
              const option = selectOption as HTMLOptionElement;
              if (target.dataset.value === option.value) {
                option.selected = true;
              } else {
                option.selected = false;
              }
            });

            originalSelect?.dispatchEvent(new Event("change"));
          }
        });
      });
    }
    function setOptionState() {
      const selectedItems = select.querySelectorAll(".selected");
      const originalSelectOptions = select.nextElementSibling?.querySelectorAll(
        "option:not([disabled='disabled'])"
      ) as NodeListOf<HTMLElement>;
      const selectTitleElement = select.querySelector(".form-header span");
      const selectTitle = selectTitleElement?.getAttribute("data-title") ?? "";

      if (document.documentElement.clientWidth > 800) {
        originalSelectOptions.forEach((originalSelectOption) => {
          (originalSelectOption as HTMLOptionElement).selected = false;
        });

        selectedItems.forEach((selectedItem) => {
          const selectedItemElement = selectedItem as HTMLElement;
          originalSelectOptions.forEach((originalSelectOption) => {
            if (
              selectedItemElement.dataset.value ===
              (originalSelectOption as HTMLOptionElement).value
            ) {
              (originalSelectOption as HTMLOptionElement).selected = true;
            }
          });
        });
      }

      if (selectedItems.length === 0) {
        if (selectTitleElement) {
          selectTitleElement.innerHTML = selectTitle;
        }
        select.classList.remove("has-selection");
      } else if (selectedItems.length === 1) {
        if (selectTitleElement) {
          selectTitleElement.innerHTML =
            (selectedItems[0] as HTMLElement).querySelector(".textbox")
              ?.innerHTML ?? "";
        }
        select.classList.add("has-selection");
      } else {
        selectedItems.forEach((selectedItem, index) => {
          if (index === 0) {
            if (selectTitleElement) {
              selectTitleElement.innerHTML =
                (selectedItem as HTMLElement).querySelector(".textbox")
                  ?.innerHTML ?? "";
            }
          } else {
            if (selectTitleElement) {
              selectTitleElement.innerHTML += `, ${
                (selectedItem as HTMLElement).querySelector(".textbox")
                  ?.innerHTML ?? ""
              }`;
            }
          }
        });

        select.classList.add("has-selection");
      }

      if (document.documentElement.clientWidth < 800) {
        const selectedOptions = Array.from(originalSelectOptions)
          .filter((option) => (option as HTMLOptionElement).selected)
          .map((option) => (option as HTMLOptionElement).innerHTML);

        if (selectTitleElement) {
          selectTitleElement.innerHTML = selectedOptions.join(", ");
        }
      }
    }
  };
}